import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { useQuery } from '@apollo/client';
import { useAuth } from 'react-oidc-context';
import Avatar from 'components/common/Avatar';
import { GET_PROFILE } from 'graphql/user';
import { setProfile } from 'reducers/profileReducer';
import avatar from 'assets/img/generic/person.png';

const ProfileDropdown = () => {
  const auth = useAuth();
  const dispatch = useDispatch();
  const { firstName, lastName } = useSelector(state => state.profile);
  const { data } = useQuery(GET_PROFILE);

  useEffect(() => {
    if (!data) {
      return;
    }
    dispatch(setProfile(data.profile));
  }, [data]);

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={avatar} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Item as={Link} to="/user/profile">
            {firstName} {lastName}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} onClick={auth.signoutRedirect}>
            Log out
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
